// import React, { useState } from "react";

// const AlertDialog = ({ isOpen, onClose, onConfirm }) => {
//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50">
//       <div className="bg-white p-6 rounded-lg shadow-lg max-w-sm w-full">
//         <h2 className="text-lg font-semibold text-center">Are you sure?</h2>
//         <p className="text-gray-600 mt-2 text-center">This action cannot be undone.</p>
//         <div className="mt-4 flex justify-between space-x-3">
//           <button
//             className="px-10 py-2 text-gray-700 bg-gray-200 rounded hover:bg-gray-300"
//             onClick={onClose}>
//             Cancel
//           </button>
//           <button
//             className="px-10 py-2 text-white bg-red-600 rounded hover:bg-red-700"
//             onClick={onConfirm}>
//             Delete
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// const DeleteButton = ({ onDelete, style, delete_icon, is_disabled }) => {
//   const [isAlertOpen, setIsAlertOpen] = useState(false);

//   return (
//     <div>
//       <button
//         className={style}
//         disabled={is_disabled}
//         onClick={() => setIsAlertOpen(true)}>
//         {delete_icon}
//         Delete
//       </button>

//       <AlertDialog
//         isOpen={isAlertOpen}
//         onClose={() => setIsAlertOpen(false)}
//         onConfirm={() => {
//             onDelete(); 
//             setIsAlertOpen(false);
//         }}
//       />
//     </div>
//   );
// };

// export default DeleteButton;


import React, { useState, useEffect } from "react";

const AlertDialog = ({ isOpen, onClose, onConfirm }) => {
  const [animateClass, setAnimateClass] = useState("");

  useEffect(() => {
    if (isOpen) {
      setAnimateClass("md:animate-none animate-slideUp");
    } else if (animateClass.includes("animate-slideUp")) {
      setAnimateClass("md:animate-none animate-slideDown");
      setTimeout(() => setAnimateClass(""), 300);
    }
  }, [isOpen]);

  if (!isOpen && animateClass !== "animate-slideDown") return null;

  return (
    <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex justify-center items-end md:items-center z-50 backdrop-blur-sm">
      <div
        className={`bg-white dark:bg-black p-6 rounded-t-lg md:rounded-lg shadow-lg w-full max-w-sm mx-auto transition-transform duration-300 ${animateClass}`}
      >
        <h2 className="text-lg font-semibold text-center dark:text-white">Are you sure?</h2>
        <p className="text-gray-600 mt-2 text-center dark:text-gray-500">This action cannot be undone.</p>
        <div className="mt-4 flex justify-between space-x-3">
          <button
            className=" block w-full py-2 dark:hover:bg-gray-900 dark:bg-black dark:text-white dark:focus:outline-none border border-gray-300 rounded-md"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="px-10 py-2 text-white bg-red-600 rounded hover:bg-red-700 w-full"
            onClick={() => {
              onConfirm();
              onClose();
            }}
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

const DeleteButton = ({ onDelete, style, delete_icon, is_disabled }) => {
  const [isAlertOpen, setIsAlertOpen] = useState(false);

  return (
    <div>
      <button
        className={style}
        disabled={is_disabled}
        onClick={() => setIsAlertOpen(true)}
      >
        {delete_icon ? delete_icon : "Delete"}
      </button>

      <AlertDialog
        isOpen={isAlertOpen}
        onClose={() => setIsAlertOpen(false)}
        onConfirm={onDelete}
      />
    </div>
  );
};

export default DeleteButton;
